import React, { useState, useEffect } from 'react';
import { Checkbox, Typography } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import '../../cssfiles/homepage.css';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { getdevicetags1 } from '../../Restclient/datacollection';

const renderTreeNodes = (node, handleCheck, checkedNodes, devicename, deviceId) => {
    if (node.hasOwnProperty("TagID") && node.hasOwnProperty("Alias")) {
        const nodeKey = deviceId + node["TagID"];
        return (
            <TreeItem
                key={nodeKey}
                itemId={nodeKey}
                label={
                    <Typography sx={{ display: 'flex', alignItems: 'left', whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        <Checkbox
                            checkedIcon={<CheckBoxOutlinedIcon />}
                            style={{ color: 'var(--SecondaryText)', color: "008CD7" }}
                            checked={checkedNodes.includes(nodeKey)}
                            sx={{
                                padding: 0,
                                margin: 0,
                                color: 'var(--HighlightedText_Stroke)',
                                '& .MuiSvgIcon-root': {
                                    fontSize: '20px',
                                    color: 'var(--HighlightedText_Stroke)'
                                }
                            }}
                            onChange={(event) => handleCheck(event, node, nodeKey, devicename, deviceId)}
                        />
                        <span style={{ color: 'var(--SecondaryText)' }}>{node["Alias"]}</span>
                    </Typography>
                }
                sx={{
                    '& .MuiTreeItem-label': {
                        fontSize: '16px',
                        fontWeight: 400,
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                    },
                }}
            >
            </TreeItem>
        );
    }
};

const TagSelection = ({ assetdata, assetdataerror, setSelectedTag,setSelectedAsset,setExistingDeviceTagAlarmConfig }) => {
    const [checkedNode, setCheckedNode] = useState(null); //z Holds the id of the currently checked node
    const [selectedCheckedNodeName, setSelectedCheckedNodeName] = useState(null); // Holds the name of the currently checked tree item
    const [selectedTags, setSelectedTags] = useState([]); // Array of selected tag objects
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate);
    const [pagesize, setPagesize] = useState(480);
    const [anchorEl, setAnchorEl] = useState(null);
    const themechange = useSelector((state) => state.themedata.theme)
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname)
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const [checkedNodes, setCheckedNodes] = useState([]);  
    
    useEffect(() => {
        if (overviewstate) {
            setPagesize(440);
        } else {
            setPagesize(380);
        }
      }, [overviewstate]);

    // Handle checkbox toggle
    // const fetchconfigdeviceIdTagnamecallback = (res) => {
    //     console.log("fetchconfigdeviceIdTagnamecallback existing tag",res)
    //     if(res.data.data.length>0){
    //         setExistingDeviceTagAlarmConfig(true)
    //     }else{
    //         setExistingDeviceTagAlarmConfig(false)
    //     }
    // }

    const getdevicetagscallback = (datareceived) =>{
        // console.log("getdevicetagscallback-datareceived",datareceived?.data)
    }

    // useEffect(()=>{
    //     //getdevicetags1(userdetails.Projectid,getdevicetagscallback)
    //     if(selectedprojectname != undefined || selectedprojectname != null || selectedprojectname != ''){
    //         if(userdetails && userdetails.Projectid && userdetails.Projectlist){
    //             //getalarmgroups(alarmgroupscallback)
    //             getdevicetags1(selectedprojectname,userdetails.Projectlist, assetcallback)
    //         }
    //     }
    // },[])

    const handleCheck = (event, node, nodeId, devicename, deviceId) => {
        setCheckedNodes((prevChecked) => {
            let updatedChecked;
            if (prevChecked.includes(nodeId)) {
                // Uncheck
                updatedChecked = prevChecked.filter(id => id !== nodeId);
                setSelectedTags((prevTags) => prevTags.filter(tag => tag.tagid !== node["TagID"]));
            } else {
                // Check
                updatedChecked = [...prevChecked, nodeId];
                setSelectedTags((prevTags) => [
                    ...prevTags,
                    {
                        projectid: node["ProjectID"],
                        tagid: node["TagID"],
                        tagname: node["Alias"],
                        tagunit: node["Unit"],
                        std_tagname: node["PayloadName"],
                        tagdatatype: node["DataType"]
                    }
                ]);
            }
            // Output the array of selected tags
        setSelectedTag(
                updatedChecked.length === 0
                    ? []
                    : [
                        ...selectedTags.filter(tag => updatedChecked.includes(deviceId + tag.tagid)),
                        ...(prevChecked.includes(nodeId)
                            ? []
                            : [{
                                projectid: node["ProjectID"],
                                tagid: node["TagID"],
                                tagname: node["Alias"],
                                tagunit: node["Unit"],
                                std_tagname: node["PayloadName"],
                                tagdatatype: node["DataType"]
                            }]
                        )
                    ]
            );
            return updatedChecked;
        });
        // Optionally update selected asset/device if needed
        //setSelectedAsset({ asset_name: devicename, device_id: deviceId });
    };

    //console.log("assetdata HERE ASSETRETRIVEAL",assetdata)
    const handleMenuItemClick = (menuOption) => {
        //console.log("Menu option selected:", menuOption);
        //setSelectedConfigurationOption(menuOption);
        setAnchorEl(null);
    }

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    //console.log("userdetails in",userdetails)
      
return (
        <div style={{ width: "310px", marginRight: "0px", marginLeft: "14px" }}>
            <Box style={{ border: "1px solid #008CD7", display: 'flex', flexDirection: 'column', height: "360px", padding: '0px 16px', overflowY: "scroll" }}>
                {(assetdataerror == true) &&
                    <Typography sx={{ fontSize: "16px", fontFamily: "Roboto", color: 'var(--SecondaryText)', fontWeight: 400, marginLeft: "0px", marginTop: "6px", textAlign: "left" }}>{'Devices not found'}</Typography>}
                {(assetdataerror == false) &&
                    <>
                        {((assetdata !== null) && (assetdata !== undefined)) ? (
                            assetdata.hasOwnProperty("devices") ? (
                                ((assetdata["devices"] != null) && (assetdata["devices"] != undefined) && (assetdata["devices"].length > 0)) ?
                                    assetdata["devices"].map((objecttreeview, index) => {
                                        if (objecttreeview.hasOwnProperty("ProjectID")) {
                                            if (objecttreeview.hasOwnProperty("DeviceName") && objecttreeview.hasOwnProperty("tagdetails") && Array.isArray(objecttreeview["tagdetails"])) {
                                                return (
                                                    <div style={{ display: "block" }} key={index}>
                                                        <SimpleTreeView sx={{
                                                            color: 'var(--SecondaryText)', '& .MuiTreeItem-label .MuiTreeItem-content': {
                                                                fontSize: '16px',
                                                                fontWeight: 400,
                                                                color: "red",
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden'
                                                            },
                                                        }} defaultCollapseIcon="-" defaultExpandIcon="+">
                                                            <TreeItem itemId={objecttreeview["DeviceID"]} label={objecttreeview["DeviceName"]} sx={{
                                                                '& .MuiTreeItem-label': {
                                                                    fontSize: '16px',
                                                                    fontWeight: 400,
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden'
                                                                },
                                                            }}>
                                                                {objecttreeview["tagdetails"].map((tagGroup, index) =>
                                                                    renderTreeNodes(tagGroup, handleCheck, checkedNodes, objecttreeview["DeviceName"], objecttreeview["DeviceID"])
                                                                )}
                                                            </TreeItem>
                                                        </SimpleTreeView>
                                                    </div>
                                                );
                                            } else {
                                                return <></>;
                                            }
                                        } else {
                                            <></>;
                                        }
                                    }) : <></>
                            ) : <></>
                        ) : <></>}
                    </>}
            </Box>
        </div>
    );
};

export default TagSelection;

